import React from 'react';
import styles from './LoadingLogo.module.css';
import logoImg from './fff-logo.png';

const LoadingLogo = () => (
  <div className={styles.container}>
    <img className={styles.loadingImage} src={logoImg} alt="Loading..." />
  </div>
);

export default LoadingLogo;
